import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { api } from '../URL/api-url';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeNetService {

  constructor(private http: HttpClient) { }
  // authorize-net.service.ts
updatePaymentStatus(data: any) {
  return this.http.patch(`${api.url}/authorize-net/update-status`, data);
}


}
